import { ReactNode } from 'react';

import { colors } from '../../colors';
import { EditIcon } from '../icons';
import { Heading3 } from '../Text';

import * as css from './EditableTag.css';

type EditableTagProps = {
    /** Content displayed inside the tag. */
    children: ReactNode;

    /** Marks the tag as visually selected (ignored when editable). @default false */
    isSelected?: boolean;

    /** Shows edit icon when clickable. @default false */
    isEditable?: boolean;

    /** Click handler; enables button behavior when provided. */
    onClick?: () => void;
};

export function EditableTag({ isSelected = false, isEditable = false, onClick, children }: EditableTagProps) {
    const clickable = typeof onClick === 'function';
    const editable = clickable && isEditable;
    const selected = isSelected && !editable;

    return (
        <div role={clickable ? 'button' : undefined} onClick={onClick} className={css.tag({ selected })}>
            <Heading3 as="span">{children}</Heading3>

            {editable && <EditIcon size={18} color={colors.blue[500]} weight="fill" />}
        </div>
    );
}
